export class CatalogDetails {
    id: string;
    name: string;
    code: string;
    keywords: string[];
    domainSpecific: boolean;
    online: boolean;
    buyerDomains: any[];
    sellerDomains: any[];
    catalogSvg?: string;
    lmsCatalog: boolean
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/catalogs/details/catalog-details.model.ts